import { set, toggle } from "@/utils/vuex";

export default {
  // setMe: set("me"),
  setMe: (state, { me }) => (state.me = me),
  setMyAgentsCount: set("myAgentsCount"),
  setMyAgentsSort: set("myAgentsSort"),
  setMyAgentsSortDesc: set("myAgentSortDesc"),
  // setMyBrokerage: set("myBrokerage"),
  setMyBrokerage: (state, { brokerage }) => (state.myBrokerage = brokerage),
  setMyLoanOffice: (state, { loanOffice }) => (state.myLoanOffice = loanOffice),
  setAgent: (state, agent) => (state.agent = agent),
  toggleIsLoadingMe: toggle("isLoadingMe"),
  toggleDrawer: toggle("drawer"),
  setDrawer: set("drawer"),
  setResponsive: set("responsive"),
  toggleMobileBrokerSort: toggle("mobileBrokerSort"),
  toggleMobileAgentSort: toggle("mobileAgentSort"),
  toggleMobileBrokerSearch: toggle("mobileBrokerSearch"),
  toggleMobileAgentSearch: toggle("mobileAgentSearch"),
  setAgentDetailsActiveTab: set("agentDetailsActiveTab"),
  setBrokerBoostStatus: set("brokerBoostStatus"),
  setUserType: set("userType"),
};
